import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getContact,
  getContactData,
  getContactError,
  getContactStatus,
} from "../../../redux/slice/contactSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import UpperSection from "../common/UpperSection";
import ContactSubmittedList from "./ContactSubmittedList";

const AdminContactSubmitted = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const data = useSelector(getContactData);
  const status = useSelector(getContactStatus);
  const error = useSelector(getContactError);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(getContact());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredResult = data?.filter((result) => {
    return result?.name?.toLowerCase().includes(searchQuery);
  });

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type="failed" message={error} /> : null}
      {/* Upper Section */}
      <UpperSection
        title="Contact Form Data"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <ContactSubmittedList data={filteredResult} />
    </section>
  );
};

export default AdminContactSubmitted;
